import request from './request';





//展商列表
export function company_lists(params) {
    return request({
        url:'/pc/company/lists',
        method: 'get',
        params
    })
}


//展商详情
export function company_detail(params) {
    return request({
        url:'/pc/company/detail',
        method: 'get',
        params
    })
}